// extracted by mini-css-extract-plugin
export default {"layout":"WritingCount_layout__aOMeq","writingCount":"WritingCount_writingCount__dE8RZ","count":"WritingCount_count__54eIs"};